import React, { useState } from "react"
import moment from "moment-timezone";

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

export default function DocumentCard(props) {
    const [active, setActive] = useState(false);
    function toggleActive() {
        setActive(!active)
    }

    function Attachments() {
        if(props.document.attachments.length > 0){
            if(active){
                return(
                    <>{props.document.attachments.map(attachment => (
                    <div key={attachment.id} className="pb-4 pt-2 bg-zinc-200 border-zinc-300 dark:bg-zinc-700 border-t-2">
                        <a href={attachment.file.localFile.publicURL} target="_blank" className="pl-4 mr-4">{attachment.title}</a>
                        <span className="text-sm text-zinc-500 dark:text-zinc-400">{attachment.file.localFile.prettySize}</span>
                    </div>
                    ))}
                    <div className="text-center bg-zinc-300 dark:bg-zinc-800 border-zinc-300 border-t-2 rounded-b-3xl">
                        <button onClick={toggleActive} className="">Hide Attachments</button>
                    </div>
                    </>
                )
            } else {
                return(
                    <div className="text-center bg-zinc-300 border-zinc-300 border-t-2 rounded-b-3xl dark:bg-zinc-800">
                        <button onClick={toggleActive} className="">Show Attachments</button>
                    </div>
                )
            }
        } else {
            return (<></>)
        }
    }
    return (
          <div className="">
            <div className="bg-zinc-100 dark:bg-zinc-600 shadow-lg rounded-3xl">
              <div className="bg-zinc-300 dark:bg-zinc-800 rounded-t-3xl leading-tight text-center p-4">
                <p className="mb-0">{props.document.title}<br />
                <small className="">{moment(props.document.publish_date).format("ll")}</small>
                </p>
              </div>
                <div className="pb-4 pt-2">
                    <a href={props.document.document.localFile.publicURL} target="_blank" className="pl-4 mr-4">View Document</a>
                    <span className="text-sm text-zinc-500 dark:text-zinc-400">{props.document.document.localFile.prettySize}</span>
                </div>
                <Attachments />
                </div>
          </div>
    )
}